import { RouteFactory } from "@app/routePaths";
import { IconTypeEnum } from "@components/Icon/utils/types";
import { Type } from "@typings/enums";

import { PodcastIconTypeMap } from "./types";

export const ELEMENTS_TYPE_TO_EXCLUDE = [
  Type.Headline.valueOf(),
  Type.Kicker.valueOf(),
  Type.Standfirst.valueOf(),
  Type.Slug.valueOf(),
  Type.ExternalLink.valueOf(),
  Type.InternalLink.valueOf(),
  Type.Map.valueOf(),
  Type.Endnote.valueOf(),
  Type.Relation.valueOf(),
];

export const KEYWORDS_TO_DISPLAY_MORE_SECTION = [
  RouteFactory.keywordsBudget2025,
];

export const PODCASTS_SUBSCRIBERS: PodcastIconTypeMap = {
  "Apple Podcasts": IconTypeEnum.applePodcasts,
  Spotify: IconTypeEnum.spotify,
  YouTube: IconTypeEnum.youtube,
};

export const IS_DISPLAY_GIFT_AN_ARTICLE = false;
